export default __webpack_public_path__ + "static/media/1.fa67aa8d.jpg";